"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _fuse = _interopRequireDefault(require("fuse.js"));

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _solarReact2 = require("@probeton/solar-react");

var _TicketCardList = _interopRequireDefault(require("./TicketCardList"));

var _excluded = ["tickets", "loading", "onCreateCertificate", "title", "tabs", "ExtraComponent", "extraComponentProps", "onlyMine", "setOnlyMine", "labels"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TicketSearch = function TicketSearch(_ref) {
  var _tickets = _ref.tickets,
      loading = _ref.loading,
      onCreateCertificate = _ref.onCreateCertificate,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Certificaataanpassingen' : _ref$title,
      tabs = _ref.tabs,
      ExtraComponent = _ref.ExtraComponent,
      extraComponentProps = _ref.extraComponentProps,
      onlyMine = _ref.onlyMine,
      setOnlyMine = _ref.setOnlyMine,
      labels = _ref.labels,
      other = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(Object.keys(tabs)[0]),
      _useState2 = _slicedToArray(_useState, 2),
      tabIndex = _useState2[0],
      setTabIndex = _useState2[1];

  var tickets = _tickets.filter(function (_ref2) {
    var iAmResponsible = _ref2.iAmResponsible;
    return onlyMine ? iAmResponsible : true;
  });

  var fuseSearchMemoized = (0, _react.useMemo)(function () {
    var options = {
      keys: ['unitName', 'productName', 'unitKey', 'authorName'],
      shouldSort: true,
      threshold: 0.3
    };
    var fuse = new _fuse["default"](tickets, options);
    return (0, _ramda.memoizeWith)(_ramda.identity, function (search) {
      return fuse.search(search);
    });
  }, [tickets.length]);

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var filteredTickets = search === '' ? tickets : fuseSearchMemoized(search);
  var selectedTickets = filteredTickets.filter(function (_ref3) {
    var status = _ref3.status;
    return tabs[tabIndex].statuses.includes(status);
  });
  var badgedTabs = Object.keys(tabs).reduce(function (memo, tab) {
    return _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, tab, tabs[tab].badge ? _objectSpread(_objectSpread({}, tabs[tab]), {}, {
      label: /*#__PURE__*/_react["default"].createElement(_core.Badge, {
        badgeContent: tickets.filter(function (_ref4) {
          var status = _ref4.status;
          return tabs[tab].statuses.includes(status);
        }).length,
        color: "primary"
      }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
        variant: "button"
      }, tabs[tab].label))
    }) : tabs[tab]));
  }, {});
  return /*#__PURE__*/_react["default"].createElement(_solarReact2.TabView, {
    fullWidth: false,
    indicatorColor: "secondary",
    appBarProps: {
      title: title,
      actions: /*#__PURE__*/_react["default"].createElement(_solarReact2.ResponsiveSearchField, {
        InputProps: {
          id: 'searchTickets'
        },
        placeholder: labels.search,
        value: search,
        onChange: function onChange(value) {
          return setSearch(value);
        }
      }),
      titleOnTop: false,
      extraToolbar: /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        style: {
          marginLeft: 13
        },
        control: /*#__PURE__*/_react["default"].createElement(_core.Switch, {
          checked: onlyMine,
          onChange: function onChange(event) {
            setOnlyMine(event.target.checked);
          },
          name: "limitByResponsible"
        }),
        label: labels.onlyMine
      })
    },
    tabs: badgedTabs,
    activeTab: tabIndex,
    onTabChange: function onTabChange(event, tab) {
      setTabIndex(tab);
    }
  }, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, loading ? /*#__PURE__*/_react["default"].createElement(_core.LinearProgress, {
    color: "primary"
  }) : '', /*#__PURE__*/_react["default"].createElement(_solarReact.ScrollableContent, null, /*#__PURE__*/_react["default"].createElement(_TicketCardList["default"], _extends({
    tickets: selectedTickets,
    emptyLabel: labels.empty
  }, other)), ExtraComponent && /*#__PURE__*/_react["default"].createElement(ExtraComponent, _extends({
    tickets: selectedTickets,
    tab: tabIndex,
    open: !!tabs[tabIndex].batchActions
  }, extraComponentProps)))));
};

var _default = TicketSearch;
exports["default"] = _default;